// extracted by css-extract-rspack-plugin
export default {"dot":"UiDotLoader_dot_sW8eb","dotLoader":"UiDotLoader_dotLoader_KCuOg"};